function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["isOpen", "onRequestClose", "onBackClick", "title", "subtitle", "headerIconButtonVariant", "id", "analyticsName", "trackBoxImpression", "trackButtonImpressions", "children", "contentKey", "showScrollbar", "hasPadding", "tabletAndDesktopCentered", "themeProps", "contentBgColor"];
function cov_1z9ciwl7mm() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/ContextSheet.tsx";
  var hash = "6dec98129cdbe8286d6b58d3baf4fe67fd04413d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/ContextSheet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 83,
          column: 25
        },
        end: {
          line: 83,
          column: 28
        }
      },
      "1": {
        start: {
          line: 84,
          column: 27
        },
        end: {
          line: 88,
          column: 1
        }
      },
      "2": {
        start: {
          line: 89,
          column: 27
        },
        end: {
          line: 93,
          column: 1
        }
      },
      "3": {
        start: {
          line: 94,
          column: 26
        },
        end: {
          line: 94,
          column: 28
        }
      },
      "4": {
        start: {
          line: 95,
          column: 29
        },
        end: {
          line: 95,
          column: 32
        }
      },
      "5": {
        start: {
          line: 96,
          column: 30
        },
        end: {
          line: 96,
          column: 33
        }
      },
      "6": {
        start: {
          line: 190,
          column: 57
        },
        end: {
          line: 439,
          column: 1
        }
      },
      "7": {
        start: {
          line: 210,
          column: 40
        },
        end: {
          line: 210,
          column: 55
        }
      },
      "8": {
        start: {
          line: 211,
          column: 23
        },
        end: {
          line: 214,
          column: 3
        }
      },
      "9": {
        start: {
          line: 212,
          column: 11
        },
        end: {
          line: 212,
          column: 56
        }
      },
      "10": {
        start: {
          line: 216,
          column: 2
        },
        end: {
          line: 216,
          column: 32
        }
      },
      "11": {
        start: {
          line: 218,
          column: 25
        },
        end: {
          line: 218,
          column: 91
        }
      },
      "12": {
        start: {
          line: 219,
          column: 20
        },
        end: {
          line: 219,
          column: 63
        }
      },
      "13": {
        start: {
          line: 221,
          column: 23
        },
        end: {
          line: 221,
          column: 34
        }
      },
      "14": {
        start: {
          line: 223,
          column: 37
        },
        end: {
          line: 223,
          column: 47
        }
      },
      "15": {
        start: {
          line: 225,
          column: 19
        },
        end: {
          line: 225,
          column: 56
        }
      },
      "16": {
        start: {
          line: 227,
          column: 45
        },
        end: {
          line: 246,
          column: 3
        }
      },
      "17": {
        start: {
          line: 248,
          column: 26
        },
        end: {
          line: 248,
          column: 50
        }
      },
      "18": {
        start: {
          line: 249,
          column: 31
        },
        end: {
          line: 249,
          column: 55
        }
      },
      "19": {
        start: {
          line: 250,
          column: 29
        },
        end: {
          line: 250,
          column: 49
        }
      },
      "20": {
        start: {
          line: 252,
          column: 26
        },
        end: {
          line: 267,
          column: 3
        }
      },
      "21": {
        start: {
          line: 253,
          column: 20
        },
        end: {
          line: 253,
          column: 43
        }
      },
      "22": {
        start: {
          line: 254,
          column: 4
        },
        end: {
          line: 266,
          column: 5
        }
      },
      "23": {
        start: {
          line: 255,
          column: 6
        },
        end: {
          line: 265,
          column: 9
        }
      },
      "24": {
        start: {
          line: 256,
          column: 8
        },
        end: {
          line: 258,
          column: 11
        }
      },
      "25": {
        start: {
          line: 257,
          column: 10
        },
        end: {
          line: 257,
          column: 50
        }
      },
      "26": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 264,
          column: 10
        }
      },
      "27": {
        start: {
          line: 260,
          column: 10
        },
        end: {
          line: 263,
          column: 11
        }
      },
      "28": {
        start: {
          line: 261,
          column: 12
        },
        end: {
          line: 261,
          column: 43
        }
      },
      "29": {
        start: {
          line: 262,
          column: 12
        },
        end: {
          line: 262,
          column: 22
        }
      },
      "30": {
        start: {
          line: 271,
          column: 2
        },
        end: {
          line: 284,
          column: 15
        }
      },
      "31": {
        start: {
          line: 273,
          column: 4
        },
        end: {
          line: 282,
          column: 5
        }
      },
      "32": {
        start: {
          line: 274,
          column: 6
        },
        end: {
          line: 277,
          column: 27
        }
      },
      "33": {
        start: {
          line: 275,
          column: 8
        },
        end: {
          line: 275,
          column: 74
        }
      },
      "34": {
        start: {
          line: 276,
          column: 8
        },
        end: {
          line: 276,
          column: 81
        }
      },
      "35": {
        start: {
          line: 279,
          column: 6
        },
        end: {
          line: 281,
          column: 27
        }
      },
      "36": {
        start: {
          line: 280,
          column: 8
        },
        end: {
          line: 280,
          column: 42
        }
      },
      "37": {
        start: {
          line: 283,
          column: 4
        },
        end: {
          line: 283,
          column: 39
        }
      },
      "38": {
        start: {
          line: 283,
          column: 17
        },
        end: {
          line: 283,
          column: 38
        }
      },
      "39": {
        start: {
          line: 286,
          column: 27
        },
        end: {
          line: 286,
          column: 43
        }
      },
      "40": {
        start: {
          line: 287,
          column: 42
        },
        end: {
          line: 287,
          column: 57
        }
      },
      "41": {
        start: {
          line: 290,
          column: 2
        },
        end: {
          line: 316,
          column: 19
        }
      },
      "42": {
        start: {
          line: 291,
          column: 26
        },
        end: {
          line: 302,
          column: 5
        }
      },
      "43": {
        start: {
          line: 292,
          column: 27
        },
        end: {
          line: 292,
          column: 50
        }
      },
      "44": {
        start: {
          line: 293,
          column: 32
        },
        end: {
          line: 293,
          column: 60
        }
      },
      "45": {
        start: {
          line: 294,
          column: 20
        },
        end: {
          line: 294,
          column: 56
        }
      },
      "46": {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 301,
          column: 7
        }
      },
      "47": {
        start: {
          line: 296,
          column: 29
        },
        end: {
          line: 296,
          column: 87
        }
      },
      "48": {
        start: {
          line: 297,
          column: 35
        },
        end: {
          line: 297,
          column: 68
        }
      },
      "49": {
        start: {
          line: 298,
          column: 26
        },
        end: {
          line: 298,
          column: 64
        }
      },
      "50": {
        start: {
          line: 299,
          column: 8
        },
        end: {
          line: 299,
          column: 95
        }
      },
      "51": {
        start: {
          line: 300,
          column: 8
        },
        end: {
          line: 300,
          column: 74
        }
      },
      "52": {
        start: {
          line: 304,
          column: 4
        },
        end: {
          line: 304,
          column: 26
        }
      },
      "53": {
        start: {
          line: 306,
          column: 18
        },
        end: {
          line: 310,
          column: 29
        }
      },
      "54": {
        start: {
          line: 307,
          column: 6
        },
        end: {
          line: 307,
          column: 42
        }
      },
      "55": {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 308,
          column: 29
        }
      },
      "56": {
        start: {
          line: 309,
          column: 6
        },
        end: {
          line: 309,
          column: 22
        }
      },
      "57": {
        start: {
          line: 312,
          column: 4
        },
        end: {
          line: 312,
          column: 37
        }
      },
      "58": {
        start: {
          line: 312,
          column: 17
        },
        end: {
          line: 312,
          column: 36
        }
      },
      "59": {
        start: {
          line: 318,
          column: 45
        },
        end: {
          line: 328,
          column: 3
        }
      },
      "60": {
        start: {
          line: 330,
          column: 23
        },
        end: {
          line: 352,
          column: 3
        }
      },
      "61": {
        start: {
          line: 354,
          column: 2
        },
        end: {
          line: 438,
          column: 4
        }
      },
      "62": {
        start: {
          line: 363,
          column: 29
        },
        end: {
          line: 363,
          column: 59
        }
      },
      "63": {
        start: {
          line: 441,
          column: 20
        },
        end: {
          line: 516,
          column: 1
        }
      },
      "64": {
        start: {
          line: 442,
          column: 20
        },
        end: {
          line: 442,
          column: 48
        }
      },
      "65": {
        start: {
          line: 443,
          column: 22
        },
        end: {
          line: 443,
          column: 42
        }
      },
      "66": {
        start: {
          line: 444,
          column: 21
        },
        end: {
          line: 444,
          column: 41
        }
      },
      "67": {
        start: {
          line: 449,
          column: 2
        },
        end: {
          line: 457,
          column: 9
        }
      },
      "68": {
        start: {
          line: 450,
          column: 4
        },
        end: {
          line: 456,
          column: 6
        }
      },
      "69": {
        start: {
          line: 453,
          column: 8
        },
        end: {
          line: 453,
          column: 27
        }
      },
      "70": {
        start: {
          line: 459,
          column: 62
        },
        end: {
          line: 466,
          column: 3
        }
      },
      "71": {
        start: {
          line: 460,
          column: 4
        },
        end: {
          line: 460,
          column: 45
        }
      },
      "72": {
        start: {
          line: 462,
          column: 4
        },
        end: {
          line: 462,
          column: 66
        }
      },
      "73": {
        start: {
          line: 463,
          column: 4
        },
        end: {
          line: 465,
          column: 7
        }
      },
      "74": {
        start: {
          line: 464,
          column: 6
        },
        end: {
          line: 464,
          column: 56
        }
      },
      "75": {
        start: {
          line: 468,
          column: 45
        },
        end: {
          line: 475,
          column: 3
        }
      },
      "76": {
        start: {
          line: 469,
          column: 4
        },
        end: {
          line: 469,
          column: 44
        }
      },
      "77": {
        start: {
          line: 470,
          column: 4
        },
        end: {
          line: 474,
          column: 7
        }
      },
      "78": {
        start: {
          line: 471,
          column: 6
        },
        end: {
          line: 473,
          column: 11
        }
      },
      "79": {
        start: {
          line: 477,
          column: 25
        },
        end: {
          line: 492,
          column: 3
        }
      },
      "80": {
        start: {
          line: 479,
          column: 4
        },
        end: {
          line: 481,
          column: 7
        }
      },
      "81": {
        start: {
          line: 480,
          column: 6
        },
        end: {
          line: 480,
          column: 68
        }
      },
      "82": {
        start: {
          line: 482,
          column: 4
        },
        end: {
          line: 489,
          column: 5
        }
      },
      "83": {
        start: {
          line: 484,
          column: 6
        },
        end: {
          line: 484,
          column: 31
        }
      },
      "84": {
        start: {
          line: 485,
          column: 6
        },
        end: {
          line: 485,
          column: 23
        }
      },
      "85": {
        start: {
          line: 488,
          column: 6
        },
        end: {
          line: 488,
          column: 56
        }
      },
      "86": {
        start: {
          line: 490,
          column: 4
        },
        end: {
          line: 490,
          column: 31
        }
      },
      "87": {
        start: {
          line: 491,
          column: 4
        },
        end: {
          line: 491,
          column: 30
        }
      },
      "88": {
        start: {
          line: 494,
          column: 2
        },
        end: {
          line: 515,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 190,
            column: 57
          },
          end: {
            line: 190,
            column: 58
          }
        },
        loc: {
          start: {
            line: 209,
            column: 6
          },
          end: {
            line: 439,
            column: 1
          }
        },
        line: 209
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 212,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        },
        loc: {
          start: {
            line: 212,
            column: 11
          },
          end: {
            line: 212,
            column: 56
          }
        },
        line: 212
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 252,
            column: 26
          },
          end: {
            line: 252,
            column: 27
          }
        },
        loc: {
          start: {
            line: 252,
            column: 55
          },
          end: {
            line: 267,
            column: 3
          }
        },
        line: 252
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 255,
            column: 31
          },
          end: {
            line: 255,
            column: 32
          }
        },
        loc: {
          start: {
            line: 255,
            column: 44
          },
          end: {
            line: 265,
            column: 7
          }
        },
        line: 255
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 256,
            column: 30
          },
          end: {
            line: 256,
            column: 31
          }
        },
        loc: {
          start: {
            line: 256,
            column: 36
          },
          end: {
            line: 258,
            column: 9
          }
        },
        line: 256
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 259,
            column: 34
          },
          end: {
            line: 259,
            column: 35
          }
        },
        loc: {
          start: {
            line: 259,
            column: 41
          },
          end: {
            line: 264,
            column: 9
          }
        },
        line: 259
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 271,
            column: 12
          },
          end: {
            line: 271,
            column: 13
          }
        },
        loc: {
          start: {
            line: 271,
            column: 18
          },
          end: {
            line: 284,
            column: 3
          }
        },
        line: 271
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 274,
            column: 27
          },
          end: {
            line: 274,
            column: 28
          }
        },
        loc: {
          start: {
            line: 274,
            column: 33
          },
          end: {
            line: 277,
            column: 7
          }
        },
        line: 274
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 279,
            column: 27
          },
          end: {
            line: 279,
            column: 28
          }
        },
        loc: {
          start: {
            line: 279,
            column: 33
          },
          end: {
            line: 281,
            column: 7
          }
        },
        line: 279
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 283,
            column: 11
          },
          end: {
            line: 283,
            column: 12
          }
        },
        loc: {
          start: {
            line: 283,
            column: 17
          },
          end: {
            line: 283,
            column: 38
          }
        },
        line: 283
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 290,
            column: 12
          },
          end: {
            line: 290,
            column: 13
          }
        },
        loc: {
          start: {
            line: 290,
            column: 18
          },
          end: {
            line: 316,
            column: 3
          }
        },
        line: 290
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 291,
            column: 26
          },
          end: {
            line: 291,
            column: 27
          }
        },
        loc: {
          start: {
            line: 291,
            column: 38
          },
          end: {
            line: 302,
            column: 5
          }
        },
        line: 291
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 306,
            column: 29
          },
          end: {
            line: 306,
            column: 30
          }
        },
        loc: {
          start: {
            line: 306,
            column: 35
          },
          end: {
            line: 310,
            column: 5
          }
        },
        line: 306
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 312,
            column: 11
          },
          end: {
            line: 312,
            column: 12
          }
        },
        loc: {
          start: {
            line: 312,
            column: 17
          },
          end: {
            line: 312,
            column: 36
          }
        },
        line: 312
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 363,
            column: 18
          },
          end: {
            line: 363,
            column: 19
          }
        },
        loc: {
          start: {
            line: 363,
            column: 29
          },
          end: {
            line: 363,
            column: 59
          }
        },
        line: 363
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 441,
            column: 20
          },
          end: {
            line: 441,
            column: 21
          }
        },
        loc: {
          start: {
            line: 441,
            column: 98
          },
          end: {
            line: 516,
            column: 1
          }
        },
        line: 441
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 449,
            column: 12
          },
          end: {
            line: 449,
            column: 13
          }
        },
        loc: {
          start: {
            line: 449,
            column: 18
          },
          end: {
            line: 457,
            column: 3
          }
        },
        line: 449
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 452,
            column: 6
          },
          end: {
            line: 452,
            column: 7
          }
        },
        loc: {
          start: {
            line: 452,
            column: 13
          },
          end: {
            line: 454,
            column: 7
          }
        },
        line: 452
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 459,
            column: 62
          },
          end: {
            line: 459,
            column: 63
          }
        },
        loc: {
          start: {
            line: 459,
            column: 69
          },
          end: {
            line: 466,
            column: 3
          }
        },
        line: 459
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 463,
            column: 26
          },
          end: {
            line: 463,
            column: 27
          }
        },
        loc: {
          start: {
            line: 463,
            column: 32
          },
          end: {
            line: 465,
            column: 5
          }
        },
        line: 463
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 468,
            column: 45
          },
          end: {
            line: 468,
            column: 46
          }
        },
        loc: {
          start: {
            line: 468,
            column: 52
          },
          end: {
            line: 475,
            column: 3
          }
        },
        line: 468
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 470,
            column: 26
          },
          end: {
            line: 470,
            column: 27
          }
        },
        loc: {
          start: {
            line: 470,
            column: 32
          },
          end: {
            line: 474,
            column: 5
          }
        },
        line: 470
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 477,
            column: 25
          },
          end: {
            line: 477,
            column: 26
          }
        },
        loc: {
          start: {
            line: 477,
            column: 37
          },
          end: {
            line: 492,
            column: 3
          }
        },
        line: 477
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 479,
            column: 26
          },
          end: {
            line: 479,
            column: 27
          }
        },
        loc: {
          start: {
            line: 479,
            column: 32
          },
          end: {
            line: 481,
            column: 5
          }
        },
        line: 479
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 191,
            column: 2
          },
          end: {
            line: 191,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 191,
            column: 11
          },
          end: {
            line: 191,
            column: 16
          }
        }],
        line: 191
      },
      "1": {
        loc: {
          start: {
            line: 203,
            column: 2
          },
          end: {
            line: 203,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 203,
            column: 18
          },
          end: {
            line: 203,
            column: 22
          }
        }],
        line: 203
      },
      "2": {
        loc: {
          start: {
            line: 204,
            column: 2
          },
          end: {
            line: 204,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 204,
            column: 15
          },
          end: {
            line: 204,
            column: 19
          }
        }],
        line: 204
      },
      "3": {
        loc: {
          start: {
            line: 218,
            column: 25
          },
          end: {
            line: 218,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 218,
            column: 33
          },
          end: {
            line: 218,
            column: 64
          }
        }, {
          start: {
            line: 218,
            column: 67
          },
          end: {
            line: 218,
            column: 91
          }
        }],
        line: 218
      },
      "4": {
        loc: {
          start: {
            line: 219,
            column: 20
          },
          end: {
            line: 219,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 219,
            column: 37
          },
          end: {
            line: 219,
            column: 41
          }
        }, {
          start: {
            line: 219,
            column: 44
          },
          end: {
            line: 219,
            column: 63
          }
        }],
        line: 219
      },
      "5": {
        loc: {
          start: {
            line: 225,
            column: 19
          },
          end: {
            line: 225,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 19
          },
          end: {
            line: 225,
            column: 28
          }
        }, {
          start: {
            line: 225,
            column: 32
          },
          end: {
            line: 225,
            column: 56
          }
        }],
        line: 225
      },
      "6": {
        loc: {
          start: {
            line: 228,
            column: 16
          },
          end: {
            line: 228,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 228,
            column: 33
          },
          end: {
            line: 228,
            column: 58
          }
        }, {
          start: {
            line: 228,
            column: 61
          },
          end: {
            line: 228,
            column: 77
          }
        }],
        line: 228
      },
      "7": {
        loc: {
          start: {
            line: 236,
            column: 12
          },
          end: {
            line: 236,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 236,
            column: 23
          },
          end: {
            line: 236,
            column: 29
          }
        }, {
          start: {
            line: 236,
            column: 32
          },
          end: {
            line: 236,
            column: 33
          }
        }],
        line: 236
      },
      "8": {
        loc: {
          start: {
            line: 239,
            column: 18
          },
          end: {
            line: 239,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 239,
            column: 29
          },
          end: {
            line: 239,
            column: 46
          }
        }, {
          start: {
            line: 239,
            column: 49
          },
          end: {
            line: 239,
            column: 96
          }
        }],
        line: 239
      },
      "9": {
        loc: {
          start: {
            line: 243,
            column: 15
          },
          end: {
            line: 243,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 243,
            column: 26
          },
          end: {
            line: 243,
            column: 65
          }
        }, {
          start: {
            line: 243,
            column: 68
          },
          end: {
            line: 243,
            column: 89
          }
        }],
        line: 243
      },
      "10": {
        loc: {
          start: {
            line: 244,
            column: 11
          },
          end: {
            line: 244,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 244,
            column: 22
          },
          end: {
            line: 244,
            column: 28
          }
        }, {
          start: {
            line: 244,
            column: 31
          },
          end: {
            line: 244,
            column: 37
          }
        }],
        line: 244
      },
      "11": {
        loc: {
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 254
      },
      "12": {
        loc: {
          start: {
            line: 260,
            column: 10
          },
          end: {
            line: 263,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 260,
            column: 10
          },
          end: {
            line: 263,
            column: 11
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 260
      },
      "13": {
        loc: {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 282,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 282,
            column: 5
          }
        }, {
          start: {
            line: 278,
            column: 11
          },
          end: {
            line: 282,
            column: 5
          }
        }],
        line: 273
      },
      "14": {
        loc: {
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 295
      },
      "15": {
        loc: {
          start: {
            line: 295,
            column: 10
          },
          end: {
            line: 295,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 295,
            column: 10
          },
          end: {
            line: 295,
            column: 22
          }
        }, {
          start: {
            line: 295,
            column: 26
          },
          end: {
            line: 295,
            column: 43
          }
        }, {
          start: {
            line: 295,
            column: 47
          },
          end: {
            line: 295,
            column: 52
          }
        }],
        line: 295
      },
      "16": {
        loc: {
          start: {
            line: 299,
            column: 30
          },
          end: {
            line: 299,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 299,
            column: 63
          },
          end: {
            line: 299,
            column: 72
          }
        }, {
          start: {
            line: 299,
            column: 75
          },
          end: {
            line: 299,
            column: 93
          }
        }],
        line: 299
      },
      "17": {
        loc: {
          start: {
            line: 387,
            column: 11
          },
          end: {
            line: 394,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 11
          },
          end: {
            line: 387,
            column: 19
          }
        }, {
          start: {
            line: 388,
            column: 12
          },
          end: {
            line: 393,
            column: 14
          }
        }],
        line: 387
      },
      "18": {
        loc: {
          start: {
            line: 396,
            column: 11
          },
          end: {
            line: 409,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 396,
            column: 12
          },
          end: {
            line: 396,
            column: 26
          }
        }, {
          start: {
            line: 396,
            column: 30
          },
          end: {
            line: 396,
            column: 41
          }
        }, {
          start: {
            line: 396,
            column: 45
          },
          end: {
            line: 396,
            column: 50
          }
        }, {
          start: {
            line: 396,
            column: 54
          },
          end: {
            line: 396,
            column: 62
          }
        }, {
          start: {
            line: 397,
            column: 12
          },
          end: {
            line: 408,
            column: 14
          }
        }],
        line: 396
      },
      "19": {
        loc: {
          start: {
            line: 416,
            column: 12
          },
          end: {
            line: 422,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 417,
            column: 16
          },
          end: {
            line: 417,
            column: 18
          }
        }, {
          start: {
            line: 418,
            column: 16
          },
          end: {
            line: 422,
            column: 17
          }
        }],
        line: 416
      },
      "20": {
        loc: {
          start: {
            line: 428,
            column: 21
          },
          end: {
            line: 428,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 428,
            column: 36
          },
          end: {
            line: 428,
            column: 37
          }
        }, {
          start: {
            line: 428,
            column: 40
          },
          end: {
            line: 428,
            column: 41
          }
        }],
        line: 428
      },
      "21": {
        loc: {
          start: {
            line: 430,
            column: 29
          },
          end: {
            line: 430,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 430,
            column: 29
          },
          end: {
            line: 430,
            column: 42
          }
        }, {
          start: {
            line: 430,
            column: 46
          },
          end: {
            line: 430,
            column: 73
          }
        }],
        line: 430
      },
      "22": {
        loc: {
          start: {
            line: 431,
            column: 15
          },
          end: {
            line: 431,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 431,
            column: 28
          },
          end: {
            line: 431,
            column: 29
          }
        }, {
          start: {
            line: 431,
            column: 32
          },
          end: {
            line: 431,
            column: 33
          }
        }],
        line: 431
      },
      "23": {
        loc: {
          start: {
            line: 482,
            column: 4
          },
          end: {
            line: 489,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 482,
            column: 4
          },
          end: {
            line: 489,
            column: 5
          }
        }, {
          start: {
            line: 486,
            column: 11
          },
          end: {
            line: 489,
            column: 5
          }
        }],
        line: 482
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0, 0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6dec98129cdbe8286d6b58d3baf4fe67fd04413d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1z9ciwl7mm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1z9ciwl7mm();
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.timers.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal';
import { css, Global } from '@emotion/react';
import { Box } from "../../core/index.mjs";
import { useDevice } from "../../hooks/useMedia.mjs";
import { useTheme } from "../../system/theme/index.mjs";
import { colors as colorKeys } from "../../theme/novo/index.mjs";
import { ThemedLite } from "../../theme/ODThemeLite.mjs";
import { getNavigationBarTitleId } from "./NavigationBar.mjs";
import { ModalHeader, useDisabledBodyScroll } from "./shared.mjs";

// To meet accessibility standards, the ContextSheet component must receive either title, aria-labelledby, or aria-label.

var CLOSE_TIMEOUT_MS = (cov_1z9ciwl7mm().s[0]++, 500);
var CONTENT_CLASS_NAME = (cov_1z9ciwl7mm().s[1]++, {
  base: 'BricksContextSheet',
  afterOpen: 'BricksContextSheet--after-open',
  beforeClose: 'BricksContextSheet--before-close'
});
var OVERLAY_CLASS_NAME = (cov_1z9ciwl7mm().s[2]++, {
  base: 'BricksContextSheet__Overlay',
  afterOpen: 'BricksContextSheet__Overlay--after-open',
  beforeClose: 'BricksContextSheet__Overlay--before-close'
});
var MARGIN_TOP_MOBILE = (cov_1z9ciwl7mm().s[3]++, 48);
var HEIGHT_TRANSITION_MS = (cov_1z9ciwl7mm().s[4]++, 250);
var OPACITY_TRANSITION_MS = (cov_1z9ciwl7mm().s[5]++, 200);

/**
 * These are our default modal patterns for mobile. Context sheets don’t cover
 * the whole screen but rather maintain a peek of a source view. This helps
 * users understand where they came from and quickly navigate back if they need
 * to. Also called Bottom Sheets via Google Materials
 *
 * Content Sizing
 *
 *
 * ------------------
 *
 * ContextSheets change size based on their content. On mobile, their height
 * expands up to 48px from the top of the screen and on larger screens, up to
 * 64px from the top of the screen. Their width will take up 100% of the screen
 * width, up to a max of 960px. ContextSheets allow for vertical scrolling. If
 * for some reason you don't want the ContextSheet to stick to the bottom of the
 * screen on larger devices, pass`tabletAndDesktopCentered={true}`.
 *
 * If the content of your ContextSheet is dynamic (e.g., because it's a
 * multi-step wizard), you must pass a`contentKey` that uniquely identifies the
 * content. This lets the component adjust its height to fit the updated
 * content.
 *
 * Header Props
 *
 *
 * ----------------
 *
 * ContextSheets render header content based on props:
 *
 * *   The close icon renders when you pass `onRequestClose` (this is required)
 *
 * *   A back icon renders when you pass `onBackClick`
 *
 * *   On scroll, a divider appears between the header and the content
 *
 *
 * Touch Handle
 *
 *
 * ----------------
 *
 * On mobile, ContextSheets render a bar at the top that lets users drag the
 * sheet up and down. If the user drags the sheet down more than 20% of the
 * sheet's height, the sheet will dismiss itself (just like tapping the X icon
 * or the overlay).
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * It's required to pass one of these props: `title`, `aria-labelledby`, or
 * `aria-label`. We recommend passing `title` (if you do that, the component
 * will render the appropriate `aria-labelledby` attribute for you).
 *
 * <Popover title="My Popover"> <Text>Content</Text> </Popover>
 *
 * <Popover aria-labelledby="popover-heading"> <Box> <Text
 * id="popover-heading">Heading</Text> <Text>Content</Text> </Box> </Popover>
 *
 * // Acceptable, but try to avoid because there's no visible text label
 * <Popover aria-label="Popover with Content"> <Image /> </Popover>
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * If you pass `analyticsName`, the Popover component will track:
 *
 * *   Modal impression events, if you also pass `trackBoxImpression={true}`
 *
 * *   `boxViewEvent: { targetName: "example" }`
 *
 * *   Back button events, if you also pass `onBackClick`
 *
 * *   `buttonViewEvent: { targetName: "example-back" }`
 *
 * *   `buttonHoverEvent: { targetName: "example-back" }`
 *
 * *   `buttonClickEvent: { targetName: "example-back" }`,
 *
 * *   Close button events
 *
 * *   `buttonViewEvent: { targetName: "example-close" }`
 *
 * *   `buttonHoverEvent: { targetName: "example-close" }`
 *
 * *   `buttonClickEvent: { targetName: "example-close" }`
 */
cov_1z9ciwl7mm().s[6]++;
export var ContextSheet = function ContextSheet(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? (cov_1z9ciwl7mm().b[0][0]++, false) : _ref$isOpen,
    onRequestClose = _ref.onRequestClose,
    onBackClick = _ref.onBackClick,
    title = _ref.title,
    subtitle = _ref.subtitle,
    headerIconButtonVariant = _ref.headerIconButtonVariant,
    id = _ref.id,
    analyticsName = _ref.analyticsName,
    trackBoxImpression = _ref.trackBoxImpression,
    trackButtonImpressions = _ref.trackButtonImpressions,
    children = _ref.children,
    contentKey = _ref.contentKey,
    _ref$showScrollbar = _ref.showScrollbar,
    showScrollbar = _ref$showScrollbar === void 0 ? (cov_1z9ciwl7mm().b[1][0]++, true) : _ref$showScrollbar,
    _ref$hasPadding = _ref.hasPadding,
    hasPadding = _ref$hasPadding === void 0 ? (cov_1z9ciwl7mm().b[2][0]++, true) : _ref$hasPadding,
    tabletAndDesktopCentered = _ref.tabletAndDesktopCentered,
    themeProps = _ref.themeProps,
    contentBgColor = _ref.contentBgColor,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1z9ciwl7mm().f[0]++;
  var _ref2 = (cov_1z9ciwl7mm().s[7]++, useState(false)),
    _ref3 = _slicedToArray(_ref2, 2),
    showDivider = _ref3[0],
    setShowDivider = _ref3[1];
  var handleScroll = (cov_1z9ciwl7mm().s[8]++, useCallback(function (e) {
    cov_1z9ciwl7mm().f[1]++;
    cov_1z9ciwl7mm().s[9]++;
    return setShowDivider(e.currentTarget.scrollTop > 0);
  }, []));
  cov_1z9ciwl7mm().s[10]++;
  useDisabledBodyScroll(isOpen);
  var ariaLabelledBy = (cov_1z9ciwl7mm().s[11]++, title ? (cov_1z9ciwl7mm().b[3][0]++, getNavigationBarTitleId({
    id: id
  })) : (cov_1z9ciwl7mm().b[3][1]++, props['aria-labelledby']));
  var ariaLabel = (cov_1z9ciwl7mm().s[12]++, ariaLabelledBy ? (cov_1z9ciwl7mm().b[4][0]++, null) : (cov_1z9ciwl7mm().b[4][1]++, props['aria-label']));
  var _ref4 = (cov_1z9ciwl7mm().s[13]++, useDevice()),
    isMobile = _ref4.isMobile;
  var _ref5 = (cov_1z9ciwl7mm().s[14]++, useTheme()),
    radii = _ref5.radii,
    shadows = _ref5.shadows,
    colors = _ref5.colors;
  var centered = (cov_1z9ciwl7mm().s[15]++, (cov_1z9ciwl7mm().b[5][0]++, !isMobile) && (cov_1z9ciwl7mm().b[5][1]++, tabletAndDesktopCentered));
  var contentStyles = (cov_1z9ciwl7mm().s[16]++, {
    background: contentBgColor ? (cov_1z9ciwl7mm().b[6][0]++, colorKeys[contentBgColor]) : (cov_1z9ciwl7mm().b[6][1]++, colors.neutrals0),
    WebkitOverflowScrolling: 'touch',
    outline: 'none',
    border: 'none',
    position: 'fixed',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: centered ? (cov_1z9ciwl7mm().b[7][0]++, 'auto') : (cov_1z9ciwl7mm().b[7][1]++, 0),
    padding: 0,
    boxShadow: shadows.z2,
    borderRadius: centered ? (cov_1z9ciwl7mm().b[8][0]++, radii.semiRounded) : (cov_1z9ciwl7mm().b[8][1]++, "".concat(radii.semiRounded, " ").concat(radii.semiRounded, " 0 0")),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxHeight: isMobile ? (cov_1z9ciwl7mm().b[9][0]++, "calc(100svh - ".concat(MARGIN_TOP_MOBILE, "px)")) : (cov_1z9ciwl7mm().b[9][1]++, 'calc(100svh - 64px)'),
    width: centered ? (cov_1z9ciwl7mm().b[10][0]++, 'auto') : (cov_1z9ciwl7mm().b[10][1]++, '100%'),
    maxWidth: '960px'
  });
  var contextSheetRef = (cov_1z9ciwl7mm().s[17]++, useRef());
  var childrenContainerRef = (cov_1z9ciwl7mm().s[18]++, useRef());
  var contextSheetHeight = (cov_1z9ciwl7mm().s[19]++, useRef(null));
  cov_1z9ciwl7mm().s[20]++;
  var animateToHeight = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(endHeight) {
      var element;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cov_1z9ciwl7mm().f[2]++;
            element = (cov_1z9ciwl7mm().s[21]++, contextSheetRef.current);
            cov_1z9ciwl7mm().s[22]++;
            if (!element) {
              _context.next = 9;
              break;
            }
            cov_1z9ciwl7mm().b[11][0]++;
            cov_1z9ciwl7mm().s[23]++;
            return _context.abrupt("return", new Promise(function (resolve) {
              cov_1z9ciwl7mm().f[3]++;
              cov_1z9ciwl7mm().s[24]++;
              requestAnimationFrame(function () {
                cov_1z9ciwl7mm().f[4]++;
                cov_1z9ciwl7mm().s[25]++;
                element.style.height = "".concat(endHeight, "px");
              });
              cov_1z9ciwl7mm().s[26]++;
              element.ontransitionend = function (e) {
                cov_1z9ciwl7mm().f[5]++;
                cov_1z9ciwl7mm().s[27]++;
                if (e.propertyName === 'height') {
                  cov_1z9ciwl7mm().b[12][0]++;
                  cov_1z9ciwl7mm().s[28]++;
                  element.ontransitionend = null;
                  cov_1z9ciwl7mm().s[29]++;
                  resolve();
                } else {
                  cov_1z9ciwl7mm().b[12][1]++;
                }
              };
            }));
          case 9:
            cov_1z9ciwl7mm().b[11][1]++;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function animateToHeight(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  // Read the context sheet's height once it's fully opened, and set it to a pixel value because
  // transitions don't work with height: auto
  cov_1z9ciwl7mm().s[30]++;
  useEffect(function () {
    cov_1z9ciwl7mm().f[6]++;
    var timeout;
    cov_1z9ciwl7mm().s[31]++;
    if (isOpen) {
      cov_1z9ciwl7mm().b[13][0]++;
      cov_1z9ciwl7mm().s[32]++;
      timeout = setTimeout(function () {
        cov_1z9ciwl7mm().f[7]++;
        cov_1z9ciwl7mm().s[33]++;
        contextSheetHeight.current = contextSheetRef.current.clientHeight;
        cov_1z9ciwl7mm().s[34]++;
        contextSheetRef.current.style.height = "".concat(contextSheetHeight.current, "px");
      }, CLOSE_TIMEOUT_MS);
    } else {
      cov_1z9ciwl7mm().b[13][1]++;
      cov_1z9ciwl7mm().s[35]++;
      timeout = setTimeout(function () {
        cov_1z9ciwl7mm().f[8]++;
        cov_1z9ciwl7mm().s[36]++;
        contextSheetHeight.current = null;
      }, CLOSE_TIMEOUT_MS);
    }
    cov_1z9ciwl7mm().s[37]++;
    return function () {
      cov_1z9ciwl7mm().f[9]++;
      cov_1z9ciwl7mm().s[38]++;
      return clearTimeout(timeout);
    };
  }, [isOpen]);
  var renderedChildren = (cov_1z9ciwl7mm().s[39]++, useRef(children));
  var _ref7 = (cov_1z9ciwl7mm().s[40]++, useState(false)),
    _ref8 = _slicedToArray(_ref7, 2),
    hideChildren = _ref8[0],
    setHideChildren = _ref8[1];

  // Animate the height and opacity of the context sheet when the content changes
  cov_1z9ciwl7mm().s[41]++;
  useEffect(function () {
    cov_1z9ciwl7mm().f[10]++;
    cov_1z9ciwl7mm().s[42]++;
    var animateHeight = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var contextSheet, childrenContainer, child, headerHeight, totalContentHeight, maxHeight;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cov_1z9ciwl7mm().f[11]++;
              contextSheet = (cov_1z9ciwl7mm().s[43]++, contextSheetRef.current);
              childrenContainer = (cov_1z9ciwl7mm().s[44]++, childrenContainerRef.current);
              child = (cov_1z9ciwl7mm().s[45]++, childrenContainer === null || childrenContainer === void 0 ? void 0 : childrenContainer.firstElementChild);
              cov_1z9ciwl7mm().s[46]++;
              if (!((cov_1z9ciwl7mm().b[15][0]++, contextSheet) && (cov_1z9ciwl7mm().b[15][1]++, childrenContainer) && (cov_1z9ciwl7mm().b[15][2]++, child))) {
                _context2.next = 17;
                break;
              }
              cov_1z9ciwl7mm().b[14][0]++;
              headerHeight = (cov_1z9ciwl7mm().s[47]++, contextSheet.clientHeight - childrenContainer.clientHeight);
              totalContentHeight = (cov_1z9ciwl7mm().s[48]++, headerHeight + child.scrollHeight);
              maxHeight = (cov_1z9ciwl7mm().s[49]++, window.innerHeight - MARGIN_TOP_MOBILE);
              cov_1z9ciwl7mm().s[50]++;
              _context2.next = 13;
              return animateToHeight(totalContentHeight > maxHeight ? (cov_1z9ciwl7mm().b[16][0]++, maxHeight) : (cov_1z9ciwl7mm().b[16][1]++, totalContentHeight));
            case 13:
              cov_1z9ciwl7mm().s[51]++;
              contextSheetHeight.current = contextSheetRef.current.clientHeight;
              _context2.next = 18;
              break;
            case 17:
              cov_1z9ciwl7mm().b[14][1]++;
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function animateHeight() {
        return _ref9.apply(this, arguments);
      };
    }();
    cov_1z9ciwl7mm().s[52]++;
    setHideChildren(true);
    var timer = (cov_1z9ciwl7mm().s[53]++, setTimeout(function () {
      cov_1z9ciwl7mm().f[12]++;
      cov_1z9ciwl7mm().s[54]++;
      renderedChildren.current = children;
      cov_1z9ciwl7mm().s[55]++;
      setHideChildren(false);
      cov_1z9ciwl7mm().s[56]++;
      animateHeight();
    }, OPACITY_TRANSITION_MS));
    cov_1z9ciwl7mm().s[57]++;
    return function () {
      cov_1z9ciwl7mm().f[13]++;
      cov_1z9ciwl7mm().s[58]++;
      return clearTimeout(timer);
    };

    // `children` intentionally left out of dependencies array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentKey]);
  var overlayStyles = (cov_1z9ciwl7mm().s[59]++, {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999
  });
  var globalStyles = (cov_1z9ciwl7mm().s[60]++, /*#__PURE__*/css(".", OVERLAY_CLASS_NAME.base, "{background-color:rgba(34, 34, 34, 0);transition:background-color ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", OVERLAY_CLASS_NAME.afterOpen, "{background-color:rgba(34, 34, 34, 0.6);}.", OVERLAY_CLASS_NAME.beforeClose, "{background-color:rgba(34, 34, 34, 0);}.", CONTENT_CLASS_NAME.base, "{transform:translateY(100%);transition:transform ", CLOSE_TIMEOUT_MS, "ms ease-out,height ", HEIGHT_TRANSITION_MS, "ms ease-out;}.", CONTENT_CLASS_NAME.afterOpen, "{transform:translateY(0);}.", CONTENT_CLASS_NAME.beforeClose, "{transform:translateY(100%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  cov_1z9ciwl7mm().s[61]++;
  return /*#__PURE__*/React.createElement(ReactModal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: true,
    className: CONTENT_CLASS_NAME,
    overlayClassName: OVERLAY_CLASS_NAME,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    style: {
      content: contentStyles,
      overlay: overlayStyles
    },
    contentRef: function contentRef(node) {
      cov_1z9ciwl7mm().f[14]++;
      cov_1z9ciwl7mm().s[62]++;
      return contextSheetRef.current = node;
    }
    /*
      Accessibility note: Aria-model indicates the presence of a modal element
      https://www.w3.org/TR/wai-aria-1.2/#aria-modal
    */,
    "aria-modal": isOpen
    /*
      Accessibility note: use the contentLabel prop to provide a label for the modal content
      If the modal is already labeled with visible text, you should specify the element including the label with the aria-labelledby attribute.
      https://reactcommunity.org/react-modal/accessibility/#aria-attributes
      To set aria-labelledby, either (1) pass headerProps.title and let this component set aria-labelledby for you, or (2) pass ariaLabelledBy
      and set it to the id of your custom label
    */,
    aria: {
      labelledby: ariaLabelledBy
    },
    contentLabel: ariaLabel
  }, /*#__PURE__*/React.createElement(Global, {
    styles: globalStyles
  }), /*#__PURE__*/React.createElement(ThemedLite, themeProps, /*#__PURE__*/React.createElement(React.Fragment, null, (cov_1z9ciwl7mm().b[17][0]++, isMobile) && (cov_1z9ciwl7mm().b[17][1]++, /*#__PURE__*/React.createElement(TouchHandle, {
    contextSheetRef: contextSheetRef,
    contextSheetHeight: contextSheetHeight,
    animateToHeight: animateToHeight,
    onRequestClose: onRequestClose
  })), ((cov_1z9ciwl7mm().b[18][0]++, onRequestClose) || (cov_1z9ciwl7mm().b[18][1]++, onBackClick) || (cov_1z9ciwl7mm().b[18][2]++, title) || (cov_1z9ciwl7mm().b[18][3]++, subtitle)) && (cov_1z9ciwl7mm().b[18][4]++, /*#__PURE__*/React.createElement(ModalHeader, {
    trackBoxImpression: trackBoxImpression,
    trackButtonImpressions: trackButtonImpressions,
    analyticsName: analyticsName,
    onBackClick: onBackClick,
    onRequestClose: onRequestClose,
    title: title,
    subtitle: subtitle,
    id: id,
    showDivider: showDivider,
    headerIconButtonVariant: headerIconButtonVariant
  }))), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1,
    overflowY: "scroll",
    sx: showScrollbar ? (cov_1z9ciwl7mm().b[19][0]++, {}) : (cov_1z9ciwl7mm().b[19][1]++, {
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    }),
    onScroll: handleScroll,
    ref: childrenContainerRef
  }, /*#__PURE__*/React.createElement(Box, {
    opacity: hideChildren ? (cov_1z9ciwl7mm().b[20][0]++, 0) : (cov_1z9ciwl7mm().b[20][1]++, 1),
    transition: "opacity ".concat(OPACITY_TRANSITION_MS, "ms ease-out"),
    transitionDelay: (cov_1z9ciwl7mm().b[21][0]++, !hideChildren) && (cov_1z9ciwl7mm().b[21][1]++, "".concat(HEIGHT_TRANSITION_MS, "ms")),
    p: hasPadding ? (cov_1z9ciwl7mm().b[22][0]++, 5) : (cov_1z9ciwl7mm().b[22][1]++, 0)
  }, renderedChildren.current))));
};
cov_1z9ciwl7mm().s[63]++;
var TouchHandle = function TouchHandle(_ref10) {
  var contextSheetRef = _ref10.contextSheetRef,
    contextSheetHeight = _ref10.contextSheetHeight,
    animateToHeight = _ref10.animateToHeight,
    onRequestClose = _ref10.onRequestClose;
  cov_1z9ciwl7mm().f[15]++;
  var handleRef = (cov_1z9ciwl7mm().s[64]++, useRef(null));
  var touchStartY = (cov_1z9ciwl7mm().s[65]++, useRef(null));
  var touchMoveY = (cov_1z9ciwl7mm().s[66]++, useRef(null));
  var originalTransition;

  // Prevent pull-to-refresh
  cov_1z9ciwl7mm().s[67]++;
  useEffect(function () {
    cov_1z9ciwl7mm().f[16]++;
    cov_1z9ciwl7mm().s[68]++;
    handleRef.current.addEventListener('touchstart', function (e) {
      cov_1z9ciwl7mm().f[17]++;
      cov_1z9ciwl7mm().s[69]++;
      e.preventDefault();
    }, {
      passive: false
    });
  }, []);
  cov_1z9ciwl7mm().s[70]++;
  var handleTouchStart = function handleTouchStart(e) {
    cov_1z9ciwl7mm().f[18]++;
    cov_1z9ciwl7mm().s[71]++;
    touchStartY.current = e.touches[0].pageY;
    // Remove the original transition so height changes match the touch movements exactly
    cov_1z9ciwl7mm().s[72]++;
    originalTransition = contextSheetRef.current.style.transition;
    cov_1z9ciwl7mm().s[73]++;
    requestAnimationFrame(function () {
      cov_1z9ciwl7mm().f[19]++;
      cov_1z9ciwl7mm().s[74]++;
      contextSheetRef.current.style.transition = 'none';
    });
  };
  cov_1z9ciwl7mm().s[75]++;
  var handleTouchMove = function handleTouchMove(e) {
    cov_1z9ciwl7mm().f[20]++;
    cov_1z9ciwl7mm().s[76]++;
    touchMoveY.current = e.touches[0].pageY;
    cov_1z9ciwl7mm().s[77]++;
    requestAnimationFrame(function () {
      cov_1z9ciwl7mm().f[21]++;
      cov_1z9ciwl7mm().s[78]++;
      contextSheetRef.current.style.height = "".concat(contextSheetHeight.current + touchStartY.current - touchMoveY.current, "px");
    });
  };
  cov_1z9ciwl7mm().s[79]++;
  var handleTouchEnd = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            cov_1z9ciwl7mm().f[22]++;
            cov_1z9ciwl7mm().s[80]++;
            // Restore the original transition
            requestAnimationFrame(function () {
              cov_1z9ciwl7mm().f[23]++;
              cov_1z9ciwl7mm().s[81]++;
              contextSheetRef.current.style.transition = originalTransition;
            });
            cov_1z9ciwl7mm().s[82]++;
            if (!(touchMoveY.current - touchStartY.current > contextSheetHeight.current * 0.2)) {
              _context3.next = 13;
              break;
            }
            cov_1z9ciwl7mm().b[23][0]++;
            cov_1z9ciwl7mm().s[83]++;
            _context3.next = 9;
            return animateToHeight(0);
          case 9:
            cov_1z9ciwl7mm().s[84]++;
            onRequestClose();
            _context3.next = 17;
            break;
          case 13:
            cov_1z9ciwl7mm().b[23][1]++;
            cov_1z9ciwl7mm().s[85]++;
            _context3.next = 17;
            return animateToHeight(contextSheetHeight.current);
          case 17:
            cov_1z9ciwl7mm().s[86]++;
            touchStartY.current = null;
            cov_1z9ciwl7mm().s[87]++;
            touchMoveY.current = null;
          case 21:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleTouchEnd() {
      return _ref11.apply(this, arguments);
    };
  }();
  cov_1z9ciwl7mm().s[88]++;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    px: "10",
    py: "4",
    mb: "-12px" // Bottom padding + negative margin makes tappable region larger without creating extra visible space
    ,
    zIndex: 1,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    ref: handleRef
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "neutrals20",
    width: "48px",
    height: "6px",
    borderRadius: "semiRounded",
    userSelect: "none"
  })));
};